// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Select from "../../resources/selection-and-input/Select.res.js";
import * as Scaffold from "../../bundles/Scaffold/Scaffold.res.js";
import * as JsonCodec from "../../primitives/JsonCodec.res.js";
import * as SearchBar from "../../resources/selection-and-input/SearchBar.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as CountBadge from "../../resources/feedback-indicators/CountBadge.res.js";
import * as DeviceName from "../../modules/Device/DeviceName.res.js";
import * as EmptyState from "../../resources/layout-and-structure/EmptyState.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as Illustration from "../../resources/images-and-icons/Illustration.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as CanarySeparator from "../../resources/layout-and-structure/CanarySeparator.res.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as StockActivityKind from "../../modules/StockActivity/StockActivityKind.res.js";
import * as TableDatetimeCell from "../../resources/tables/TableDatetimeCell.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as StockActivityReason from "../../modules/StockActivity/StockActivityReason.res.js";
import * as SelectDateRangeFilter from "../../resources/selection-and-input/SelectDateRangeFilter.res.js";
import * as StockActivityTypeTableCell from "../../modules/StockActivity/StockActivityTypeTableCell.res.js";
import * as StockActivitySourceTableCell from "../../modules/StockActivity/StockActivitySourceTableCell.res.js";
import * as StockActivityQuantityTableCell from "../../modules/StockActivity/StockActivityQuantityTableCell.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query CatalogVariantStockActivityPageParentQuery($cku: CKU!)  {\nvariantsByCku(cku: $cku, first: 1)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \ncku  \nformattedName  \n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.variantsByCku;
  let value$2 = value$1.edges;
  return {
    variantsByCku: {
      __typename: value$1.__typename,
      edges: value$2.map(value => {
        let value$1 = value.node;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            cku: Scalar.CKU.parse(value$1.cku),
            formattedName: value$1.formattedName
          }
        };
      })
    }
  };
}

function serialize(value) {
  let value$1 = value.variantsByCku;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.formattedName;
    let value$3 = value$1.cku;
    let value$4 = Scalar.CKU.serialize(value$3);
    let value$5 = value$1.id;
    let value$6 = value$1.__typename;
    let node = {
      __typename: value$6,
      id: value$5,
      cku: value$4,
      formattedName: value$2
    };
    let value$7 = value.__typename;
    return {
      __typename: value$7,
      node: node
    };
  });
  let value$3 = value$1.__typename;
  let variantsByCku = {
    __typename: value$3,
    edges: edges
  };
  return {
    variantsByCku: variantsByCku
  };
}

function serializeVariables(inp) {
  return {
    cku: inp.cku
  };
}

function makeVariables(cku, param) {
  return {
    cku: cku
  };
}

let ParentQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let ParentQuery_refetchQueryDescription = include.refetchQueryDescription;

let ParentQuery_useLazy = include.useLazy;

let ParentQuery_useLazyWithVariables = include.useLazyWithVariables;

let ParentQuery = {
  ParentQuery_inner: ParentQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  refetchQueryDescription: ParentQuery_refetchQueryDescription,
  use: use,
  useLazy: ParentQuery_useLazy,
  useLazyWithVariables: ParentQuery_useLazyWithVariables
};

let Raw$1 = {};

let query$1 = Client.gql(["query CatalogVariantStockActivityPageQuery($cku: CKU!, $filterBy: InputStockActivitiesQueryFilter, $search: String, $before: String, $after: String, $first: Int, $last: Int)  {\nstockActivitiesByVariantCku(cku: $cku, search: $search, filterBy: $filterBy, before: $before, after: $after, first: $first, last: $last)  {\n__typename  \npageInfo  {\n__typename  \nstartCursor  \nendCursor  \n}\n\ntotalCount  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nkind  \nreason  \ncomment  \nshop  {\n__typename  \nname  \n}\n\ndevice  {\n__typename  \nname  \nslug  \n}\n\ncreatedAt  \nquantity  \nvariant  {\n__typename  \ncapacityPrecision  \ncapacityUnit  \nbulk  \n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse$1(value) {
  let value$1 = value.stockActivitiesByVariantCku;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.startCursor;
  let value$4 = value$2.endCursor;
  let value$5 = value$1.edges;
  return {
    stockActivitiesByVariantCku: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        startCursor: !(value$3 == null) ? value$3 : undefined,
        endCursor: !(value$4 == null) ? value$4 : undefined
      },
      totalCount: value$1.totalCount,
      edges: value$5.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.kind;
        let tmp;
        switch (value$2) {
          case "CREDIT_MEMO" :
            tmp = "CREDIT_MEMO";
            break;
          case "DELIVERY" :
            tmp = "DELIVERY";
            break;
          case "DELIVERY_RECEIPT" :
            tmp = "DELIVERY_RECEIPT";
            break;
          case "INCOMING_TRANSFER" :
            tmp = "INCOMING_TRANSFER";
            break;
          case "LOSS" :
            tmp = "LOSS";
            break;
          case "OUTGOING_TRANSFER" :
            tmp = "OUTGOING_TRANSFER";
            break;
          case "RECEPTION" :
            tmp = "RECEPTION";
            break;
          case "REFUND" :
            tmp = "REFUND";
            break;
          case "RESET" :
            tmp = "RESET";
            break;
          case "SALE" :
            tmp = "SALE";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        let value$3 = value$1.reason;
        let tmp$1;
        if (value$3 == null) {
          tmp$1 = undefined;
        } else {
          let tmp$2;
          switch (value$3) {
            case "CORKY" :
              tmp$2 = "CORKY";
              break;
            case "DAMAGE" :
              tmp$2 = "DAMAGE";
              break;
            case "LOSS" :
              tmp$2 = "LOSS";
              break;
            case "OTHER" :
              tmp$2 = "OTHER";
              break;
            case "OUTDATED_DLUO" :
              tmp$2 = "OUTDATED_DLUO";
              break;
            case "SALE_BY_GLASS" :
              tmp$2 = "SALE_BY_GLASS";
              break;
            case "TASTING" :
              tmp$2 = "TASTING";
              break;
            case "THEFT" :
              tmp$2 = "THEFT";
              break;
            case "TRADE_IN_SUPPLIER" :
              tmp$2 = "TRADE_IN_SUPPLIER";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$1 = tmp$2;
        }
        let value$4 = value$1.comment;
        let value$5 = value$1.shop;
        let value$6 = value$1.device;
        let value$7 = value$1.variant;
        let tmp$3;
        if (value$7 == null) {
          tmp$3 = undefined;
        } else {
          let value$8 = value$7.capacityPrecision;
          let value$9 = value$7.capacityUnit;
          let value$10 = value$7.bulk;
          tmp$3 = {
            __typename: value$7.__typename,
            capacityPrecision: !(value$8 == null) ? value$8 : undefined,
            capacityUnit: !(value$9 == null) ? value$9 : undefined,
            bulk: !(value$10 == null) ? value$10 : undefined
          };
        }
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            kind: tmp,
            reason: tmp$1,
            comment: !(value$4 == null) ? Scalar.Text.parse(value$4) : undefined,
            shop: {
              __typename: value$5.__typename,
              name: value$5.name
            },
            device: {
              __typename: value$6.__typename,
              name: value$6.name,
              slug: value$6.slug
            },
            createdAt: Scalar.Datetime.parse(value$1.createdAt),
            quantity: value$1.quantity,
            variant: tmp$3
          }
        };
      })
    }
  };
}

function serialize$1(value) {
  let value$1 = value.stockActivitiesByVariantCku;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.variant;
    let variant;
    if (value$2 !== undefined) {
      let value$3 = value$2.bulk;
      let bulk = value$3 !== undefined ? value$3 : null;
      let value$4 = value$2.capacityUnit;
      let capacityUnit = value$4 !== undefined ? value$4 : null;
      let value$5 = value$2.capacityPrecision;
      let capacityPrecision = value$5 !== undefined ? value$5 : null;
      let value$6 = value$2.__typename;
      variant = {
        __typename: value$6,
        capacityPrecision: capacityPrecision,
        capacityUnit: capacityUnit,
        bulk: bulk
      };
    } else {
      variant = null;
    }
    let value$7 = value$1.quantity;
    let value$8 = value$1.createdAt;
    let value$9 = Scalar.Datetime.serialize(value$8);
    let value$10 = value$1.device;
    let value$11 = value$10.slug;
    let value$12 = value$10.name;
    let value$13 = value$10.__typename;
    let device = {
      __typename: value$13,
      name: value$12,
      slug: value$11
    };
    let value$14 = value$1.shop;
    let value$15 = value$14.name;
    let value$16 = value$14.__typename;
    let shop = {
      __typename: value$16,
      name: value$15
    };
    let value$17 = value$1.comment;
    let comment = value$17 !== undefined ? Scalar.Text.serialize(value$17) : null;
    let value$18 = value$1.reason;
    let reason = value$18 !== undefined ? (
        value$18 === "DAMAGE" ? "DAMAGE" : (
            value$18 === "OUTDATED_DLUO" ? "OUTDATED_DLUO" : (
                value$18 === "SALE_BY_GLASS" ? "SALE_BY_GLASS" : (
                    value$18 === "THEFT" ? "THEFT" : (
                        value$18 === "TASTING" ? "TASTING" : (
                            value$18 === "LOSS" ? "LOSS" : (
                                value$18 === "OTHER" ? "OTHER" : (
                                    value$18 === "TRADE_IN_SUPPLIER" ? "TRADE_IN_SUPPLIER" : "CORKY"
                                  )
                              )
                          )
                      )
                  )
              )
          )
      ) : null;
    let value$19 = value$1.kind;
    let kind = value$19 === "DELIVERY_RECEIPT" ? "DELIVERY_RECEIPT" : (
        value$19 === "RESET" ? "RESET" : (
            value$19 === "INCOMING_TRANSFER" ? "INCOMING_TRANSFER" : (
                value$19 === "DELIVERY" ? "DELIVERY" : (
                    value$19 === "REFUND" ? "REFUND" : (
                        value$19 === "LOSS" ? "LOSS" : (
                            value$19 === "CREDIT_MEMO" ? "CREDIT_MEMO" : (
                                value$19 === "SALE" ? "SALE" : (
                                    value$19 === "RECEPTION" ? "RECEPTION" : "OUTGOING_TRANSFER"
                                  )
                              )
                          )
                      )
                  )
              )
          )
      );
    let value$20 = value$1.id;
    let value$21 = value$1.__typename;
    let node = {
      __typename: value$21,
      id: value$20,
      kind: kind,
      reason: reason,
      comment: comment,
      shop: shop,
      device: device,
      createdAt: value$9,
      quantity: value$7,
      variant: variant
    };
    let value$22 = value.__typename;
    return {
      __typename: value$22,
      node: node
    };
  });
  let value$3 = value$1.totalCount;
  let value$4 = value$1.pageInfo;
  let value$5 = value$4.endCursor;
  let endCursor = value$5 !== undefined ? value$5 : null;
  let value$6 = value$4.startCursor;
  let startCursor = value$6 !== undefined ? value$6 : null;
  let value$7 = value$4.__typename;
  let pageInfo = {
    __typename: value$7,
    startCursor: startCursor,
    endCursor: endCursor
  };
  let value$8 = value$1.__typename;
  let stockActivitiesByVariantCku = {
    __typename: value$8,
    pageInfo: pageInfo,
    totalCount: value$3,
    edges: edges
  };
  return {
    stockActivitiesByVariantCku: stockActivitiesByVariantCku
  };
}

function serializeInputObjectDateFilter(inp) {
  let a = inp._after;
  let a$1 = inp._before;
  let a$2 = inp._between;
  return {
    _after: a !== undefined ? a : undefined,
    _before: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}

function serializeInputObjectInOrNotInFilter(inp) {
  let a = inp._in;
  let a$1 = inp._notIn;
  return {
    _in: a !== undefined ? a.map(b => b) : undefined,
    _notIn: a$1 !== undefined ? a$1.map(b => b) : undefined
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectInputStockActivitiesQueryFilter(inp) {
  let a = inp.kind;
  let a$1 = inp.reason;
  let a$2 = inp.date;
  let a$3 = inp.shopIds;
  return {
    kind: a !== undefined ? serializeInputObjectInOrNotInFilter(a) : undefined,
    reason: a$1 !== undefined ? serializeInputObjectInFilter(a$1) : undefined,
    date: a$2 !== undefined ? serializeInputObjectDateFilter(a$2) : undefined,
    shopIds: a$3 !== undefined ? serializeInputObjectInFilter(a$3) : undefined
  };
}

function serializeVariables$1(inp) {
  let a = inp.filterBy;
  let a$1 = inp.search;
  let a$2 = inp.before;
  let a$3 = inp.after;
  let a$4 = inp.first;
  let a$5 = inp.last;
  return {
    cku: inp.cku,
    filterBy: a !== undefined ? serializeInputObjectInputStockActivitiesQueryFilter(a) : undefined,
    search: a$1 !== undefined ? a$1 : undefined,
    before: a$2 !== undefined ? a$2 : undefined,
    after: a$3 !== undefined ? a$3 : undefined,
    first: a$4 !== undefined ? a$4 : undefined,
    last: a$5 !== undefined ? a$5 : undefined
  };
}

function makeVariables$1(cku, filterBy, search, before, after, first, last, param) {
  return {
    cku: cku,
    filterBy: filterBy,
    search: search,
    before: before,
    after: after,
    first: first,
    last: last
  };
}

function makeInputObjectInputStockActivitiesQueryFilter(kind, reason, date, shopIds, param) {
  return {
    kind: kind,
    reason: reason,
    date: date,
    shopIds: shopIds
  };
}

function makeInputObjectInOrNotInFilter(_in, _notIn, param) {
  return {
    _in: _in,
    _notIn: _notIn
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

function makeInputObjectDateFilter(_after, _before, _between, param) {
  return {
    _after: _after,
    _before: _before,
    _between: _between
  };
}

let Query_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputStockActivitiesQueryFilter: serializeInputObjectInputStockActivitiesQueryFilter,
  serializeInputObjectInOrNotInFilter: serializeInputObjectInOrNotInFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  makeVariables: makeVariables$1,
  makeInputObjectInputStockActivitiesQueryFilter: makeInputObjectInputStockActivitiesQueryFilter,
  makeInputObjectInOrNotInFilter: makeInputObjectInOrNotInFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter
};

let include$1 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1
});

let use$1 = include$1.use;

let Query_refetchQueryDescription = include$1.refetchQueryDescription;

let Query_useLazy = include$1.useLazy;

let Query_useLazyWithVariables = include$1.useLazyWithVariables;

let Query = {
  Query_inner: Query_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputStockActivitiesQueryFilter: serializeInputObjectInputStockActivitiesQueryFilter,
  serializeInputObjectInOrNotInFilter: serializeInputObjectInOrNotInFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  makeVariables: makeVariables$1,
  makeInputObjectInputStockActivitiesQueryFilter: makeInputObjectInputStockActivitiesQueryFilter,
  makeInputObjectInOrNotInFilter: makeInputObjectInOrNotInFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  refetchQueryDescription: Query_refetchQueryDescription,
  use: use$1,
  useLazy: Query_useLazy,
  useLazyWithVariables: Query_useLazyWithVariables
};

function kindToString(kind) {
  if (typeof kind !== "object") {
    return "EXCLUDING_RESET";
  } else {
    return StockActivityKind.toString(kind._0);
  }
}

function kindFromStringExn(value) {
  if (value === "EXCLUDING_RESET") {
    return "ExcludingReset";
  } else {
    return {
      TAG: "Kind",
      _0: StockActivityKind.fromStringExn(value)
    };
  }
}

function encodeValues(values) {
  if (values.length !== 0) {
    return values;
  }
}

function partitionKinds(kinds) {
  return [
    Stdlib_Array.filterMap(kinds, kind => {
      if (typeof kind !== "object") {
        return;
      } else {
        return StockActivityKind.toString(kind._0);
      }
    }),
    kinds.some(kind => kind === "ExcludingReset")
  ];
}

function encoder(param) {
  return [
    Stdlib_Option.map(param.shop, shop => shop.id),
    Stdlib_Option.map(param.dateRange, param => [
      param[0].getTime(),
      param[1].getTime()
    ]),
    encodeValues(param.kinds.map(kindToString)),
    encodeValues(param.reasons.map(StockActivityReason.toString))
  ];
}

function decoder(shops, param) {
  let shopId = param[0];
  return {
    TAG: "Ok",
    _0: {
      shop: shops.find(shop => shop.id === shopId),
      dateRange: Stdlib_Option.flatMap(param[1], range => {
        if (range.length !== 2) {
          return;
        }
        let start = range[0];
        let end = range[1];
        return [
          new Date(start),
          new Date(end)
        ];
      }),
      kinds: Stdlib_Option.getOr(param[2], []).map(kindFromStringExn),
      reasons: Stdlib_Option.getOr(param[3], []).map(StockActivityReason.fromStringExn)
    }
  };
}

function useJsonCodec() {
  let shops = Auth.useShops();
  return JsonCodec.object4(encoder, arg => decoder(shops, arg), JsonCodec.optional(JsonCodec.field("shopId", JsonCodec.string)), JsonCodec.optional(JsonCodec.field("dateRange", JsonCodec.array(JsonCodec.float))), JsonCodec.optional(JsonCodec.field("kinds", JsonCodec.array(JsonCodec.string))), JsonCodec.optional(JsonCodec.field("reasons", JsonCodec.array(JsonCodec.string))));
}

let Filters = {
  kindToString: kindToString,
  kindFromStringExn: kindFromStringExn,
  encodeValues: encodeValues,
  partitionKinds: partitionKinds,
  encoder: encoder,
  decoder: decoder,
  useJsonCodec: useJsonCodec
};

let all = {
  kind: undefined,
  reason: undefined
};

let allButReset = {
  kind: "ExcludingReset",
  reason: undefined
};

function ofKind(value) {
  return {
    kind: {
      TAG: "Kind",
      _0: value
    },
    reason: undefined
  };
}

function ofLossReason(value) {
  return {
    kind: {
      TAG: "Kind",
      _0: "LOSS"
    },
    reason: value
  };
}

function isLossReason(param) {
  return Stdlib_Option.isSome(param.reason);
}

function ofFilters(param) {
  let reasons = param.reasons;
  let kinds = param.kinds;
  if (kinds.length === 0 && reasons.length === 0) {
    return [all];
  }
  return kinds.flatMap(kind => {
    if (typeof kind !== "object") {
      return [allButReset];
    }
    let value = kind._0;
    if (value === "LOSS") {
      if (reasons.length !== 0) {
        return [];
      } else {
        return StockActivityReason.values.map(ofLossReason);
      }
    } else {
      return [ofKind(value)];
    }
  }).concat(reasons.map(ofLossReason));
}

function toFilters(values) {
  let kinds = Stdlib_Array.reduce(values, [], (acc, param) => {
    let kind = param.kind;
    if (kind !== undefined && !acc.some(value => Primitive_object.equal(value, kind))) {
      return acc.concat([kind]);
    } else {
      return acc;
    }
  });
  let reasons = Stdlib_Array.filterMap(values, param => param.reason);
  let everyReasonSelected = StockActivityReason.values.every(value => reasons.includes(value));
  return [
    kinds,
    everyReasonSelected ? [] : reasons
  ];
}

let KindFilter = {
  all: all,
  allButReset: allButReset,
  ofKind: ofKind,
  ofLossReason: ofLossReason,
  isLossReason: isLossReason,
  ofFilters: ofFilters,
  toFilters: toFilters
};

let Row = {};

function makeQueryVariables(defaultQueryVariables, connectionArguments, search, filterBy, param) {
  return {
    cku: defaultQueryVariables.cku,
    filterBy: filterBy,
    search: search,
    before: connectionArguments.before,
    after: connectionArguments.after,
    first: connectionArguments.first,
    last: connectionArguments.last
  };
}

function makeQueryVariablesFilterBy(param) {
  let dateRange = param.dateRange;
  let shop = param.shop;
  let match = partitionKinds(param.kinds);
  let values = match[0];
  let tmp;
  let exit = 0;
  if (values.length !== 0 || match[1]) {
    exit = 1;
  } else {
    tmp = undefined;
  }
  if (exit === 1) {
    tmp = {
      _in: encodeValues(values),
      _notIn: match[1] ? [StockActivityKind.toString("RESET")] : undefined
    };
  }
  return makeInputObjectInputStockActivitiesQueryFilter(tmp, Stdlib_Option.map(encodeValues(param.reasons.map(StockActivityReason.toString)), values => ({
    _in: values
  })), dateRange !== undefined ? ({
      _after: undefined,
      _before: undefined,
      _between: [
        Scalar.Datetime.serialize(dateRange[0]),
        Scalar.Datetime.serialize(dateRange[1])
      ]
    }) : undefined, shop !== undefined ? ({
      _in: [shop.id]
    }) : undefined, undefined);
}

function totalCountFromQueryData(param) {
  return param.stockActivitiesByVariantCku.totalCount;
}

function cursorsFromQueryData(param) {
  let stockActivitiesByVariantCku = param.stockActivitiesByVariantCku;
  return [
    stockActivitiesByVariantCku.pageInfo.startCursor,
    stockActivitiesByVariantCku.pageInfo.endCursor
  ];
}

function rowsFromQueryDataAndState(param, param$1) {
  return Stdlib_Array.filterMap(param.stockActivitiesByVariantCku.edges, param => {
    let node = param.node;
    let variant = node.variant;
    if (variant === undefined) {
      return;
    }
    let match = variant.bulk;
    let match$1 = variant.capacityPrecision;
    let match$2 = variant.bulk;
    let match$3 = variant.capacityUnit;
    return {
      id: node.id,
      formattedKind: StockActivityKind.toLabel(node.kind),
      kind: node.kind,
      reason: node.reason,
      quantity: node.quantity,
      variantCapacityPrecision: match !== undefined && match && match$1 !== undefined ? match$1 : undefined,
      variantCapacityUnit: match$2 !== undefined && match$2 && match$3 !== undefined ? match$3 : undefined,
      description: node.comment,
      date: node.createdAt,
      shopName: node.shop.name,
      deviceName: DeviceName.format(DeviceName.decode(node.device.slug, node.device.name))
    };
  });
}

function keyExtractor(param) {
  return param.id;
}

let Scaffolded = Scaffold.Make({
  useFiltersJsonCodec: useJsonCodec,
  QueryInner: Query_inner,
  useQuery: use$1,
  makeQueryVariables: makeQueryVariables,
  makeQueryVariablesFilterBy: makeQueryVariablesFilterBy,
  cursorsFromQueryData: cursorsFromQueryData,
  totalCountFromQueryData: totalCountFromQueryData,
  rowsFromQueryDataAndState: rowsFromQueryDataAndState,
  keyExtractor: keyExtractor
});

function use$2(initialState) {
  let match = Scaffolded.use(() => initialState);
  let dispatch = match[1];
  let state = match[0];
  React.useEffect(() => {
    let match = state.filters;
    if (match.kinds.some(kind => Primitive_object.equal(kind, {
        TAG: "Kind",
        _0: "LOSS"
      })) || match.reasons.length === 0) {
      
    } else {
      dispatch({
        TAG: "FiltersUpdated",
        _0: prev => ({
          shop: prev.shop,
          dateRange: prev.dateRange,
          kinds: prev.kinds,
          reasons: []
        })
      });
    }
  }, [state.filters]);
  return [
    state,
    dispatch
  ];
}

function CatalogVariantStockActivityPage(props) {
  let scope = Auth.useScope();
  let activeShop = Auth.useActiveShop();
  let hasOrganisationScope;
  hasOrganisationScope = scope.TAG === "Organisation";
  let cku = Scalar.CKU.serialize(props.cku);
  let match = use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
    cku: cku
  });
  let match$1 = match.data;
  let pageSubtitle;
  let exit = 0;
  if (match$1 !== undefined) {
    let match$2 = match$1.variantsByCku.edges;
    if (match$2.length !== 1) {
      exit = 1;
    } else {
      let match$3 = match$2[0];
      pageSubtitle = match$3.node.formattedName;
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    pageSubtitle = match.error !== undefined ? undefined : I18n.t("Loading") + "...";
  }
  let initialState = Scaffolded.makeInitialState({
    shop: activeShop,
    dateRange: undefined,
    kinds: [],
    reasons: []
  });
  let match$4 = use$2(initialState);
  let dispatch = match$4[1];
  let state = match$4[0];
  let defaultQueryVariables = makeVariables$1(cku, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let columns = [
    {
      name: I18n.t("Type"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 100
        },
        width: {
          NAME: "fr",
          VAL: 0.5
        }
      },
      render: param => JsxRuntime.jsx(StockActivityTypeTableCell.make, {
        value: param.formattedKind,
        reason: param.reason
      })
    },
    {
      name: I18n.t("Quantity"),
      layout: {
        width: {
          NAME: "fr",
          VAL: 0.5
        },
        alignX: "center",
        sticky: true
      },
      render: param => JsxRuntime.jsx(StockActivityQuantityTableCell.make, {
        value: param.quantity,
        capacityPrecision: param.variantCapacityPrecision,
        capacityUnit: param.variantCapacityUnit,
        kind: param.kind
      })
    },
    {
      name: I18n.t("Comment"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 110
        },
        margin: "normal"
      },
      render: param => JsxRuntime.jsx(TextStyle.make, {
        children: Stdlib_Option.getOr(param.description, "—")
      })
    },
    {
      name: I18n.t("Datetime"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 110
        }
      },
      render: param => JsxRuntime.jsx(TableDatetimeCell.make, {
        value: param.date
      })
    },
    {
      name: I18n.t("Source"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 120
        }
      },
      render: param => {
        let shopName;
        shopName = scope.TAG === "Organisation" && scope.activeShop === undefined ? param.shopName : undefined;
        return JsxRuntime.jsx(StockActivitySourceTableCell.make, {
          deviceName: param.deviceName,
          shopName: shopName
        });
      }
    }
  ];
  let defaultItem_1 = I18n.t("All");
  let defaultItem_4 = true;
  let defaultItem = {
    TAG: "Option",
    key: "default",
    label: defaultItem_1,
    value: all,
    exclusive: defaultItem_4
  };
  let excludingResetItem_1 = I18n.t("All but reset");
  let excludingResetItem_4 = true;
  let excludingResetItem = {
    TAG: "Option",
    key: "excluding-reset",
    label: excludingResetItem_1,
    value: allButReset,
    exclusive: excludingResetItem_4
  };
  let lossItem_1 = StockActivityKind.toLabel("LOSS");
  let lossItem_2 = StockActivityReason.values.map(value => ({
    TAG: "Option",
    key: `reason-` + StockActivityReason.toString(value),
    label: StockActivityReason.toLabel(value),
    value: {
      kind: {
        TAG: "Kind",
        _0: "LOSS"
      },
      reason: value
    }
  }));
  let lossItem = {
    TAG: "Submenu",
    key: "kind-LOSS",
    label: lossItem_1,
    items: lossItem_2
  };
  let items = StockActivityKind.values.map(value => {
    if (value === "LOSS") {
      return lossItem;
    } else {
      return {
        TAG: "Option",
        key: `kind-` + StockActivityKind.toString(value),
        label: StockActivityKind.toLabel(value),
        value: ofKind(value)
      };
    }
  });
  let match$5 = state.filters;
  let filters = JsxRuntime.jsxs(Inline.make, {
    children: [
      hasOrganisationScope ? JsxRuntime.jsx(Auth.SelectShopFilter.make, {
          value: state.filters.shop,
          onChange: shop => dispatch({
            TAG: "FiltersUpdated",
            _0: prev => ({
              shop: shop,
              dateRange: prev.dateRange,
              kinds: prev.kinds,
              reasons: prev.reasons
            })
          })
        }) : null,
      hasOrganisationScope ? JsxRuntime.jsx(CanarySeparator.make, {}) : null,
      JsxRuntime.jsx(Select.make, {
        label: I18n.t("Kind"),
        preset: "filter",
        shouldSelectTogether: (value, other) => isLossReason(value) === isLossReason(other),
        renderValue: param => {
          let selectedItems = param.selectedItems;
          let len = selectedItems.length;
          if (len !== 1) {
            if (len === 0) {
              return I18n.t("All");
            }
          } else {
            let match = selectedItems[0];
            if (match.TAG === "Option") {
              let label = match.label;
              if (match.value.reason !== undefined) {
                return StockActivityKind.toLabel("LOSS") + ` › ` + label;
              } else {
                return label;
              }
            }
          }
          return JsxRuntime.jsx(CountBadge.make, {
            children: selectedItems.length.toString(),
            size: "small",
            tone: "brand"
          });
        },
        sections: [
          {
            items: [
              defaultItem,
              excludingResetItem
            ]
          },
          {
            items: items,
            title: I18n.t("Kinds")
          }
        ],
        value: {
          TAG: "Multiple",
          _0: ofFilters(state.filters)
        },
        onChange: change => {
          if (change.TAG === "Single") {
            return;
          }
          let match = toFilters(change._0);
          let reasons = match[1];
          let kinds = match[0];
          dispatch({
            TAG: "FiltersUpdated",
            _0: prev => ({
              shop: prev.shop,
              dateRange: prev.dateRange,
              kinds: kinds,
              reasons: reasons
            })
          });
        }
      }),
      JsxRuntime.jsx(SelectDateRangeFilter.make, {
        value: state.filters.dateRange,
        placeholder: I18n.t("Since the beginning"),
        onChange: dateRange => dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            shop: prev.shop,
            dateRange: dateRange,
            kinds: prev.kinds,
            reasons: prev.reasons
          })
        }),
        triggerLabelDisplay: "showPreset"
      }),
      (
        match$5.dateRange !== undefined ? true : match$5.kinds.length !== 0
      ) ? JsxRuntime.jsx(Scaffold.ResetFiltersButton.make, {
          onPress: () => dispatch({
            TAG: "FiltersUpdated",
            _0: param => initialState.filters
          })
        }) : null
    ],
    space: "small"
  });
  let searchBar = JsxRuntime.jsx(SearchBar.make, {
    placeholder: I18n.t("Search a stock movement"),
    value: state.searchQuery,
    onChange: searchQuery => dispatch({
      TAG: "Searched",
      _0: searchQuery
    })
  });
  let emptyState;
  let exit$1 = 0;
  if (state.currentPage !== 1 || state.searchQuery !== undefined) {
    exit$1 = 1;
  } else {
    let match$6 = state.filters;
    if (match$6.dateRange !== undefined || match$6.kinds.length !== 0 || match$6.reasons.length !== 0) {
      exit$1 = 1;
    } else {
      let exit$2 = 0;
      if (scope.TAG === "Organisation" && scope.activeShop !== undefined) {
        emptyState = JsxRuntime.jsx(EmptyState.make, {
          illustration: Illustration.noResultFound,
          title: I18n.t("Welcome to the stock movements space."),
          text: I18n.t("It seems no data exists yet for this shop.")
        });
      } else {
        exit$2 = 2;
      }
      if (exit$2 === 2) {
        emptyState = JsxRuntime.jsx(EmptyState.make, {
          illustration: Illustration.create,
          title: I18n.t("Welcome to the stock movements space.")
        });
      }
    }
  }
  if (exit$1 === 1) {
    emptyState = JsxRuntime.jsx(EmptyState.make, {
      illustration: Illustration.noResultFound,
      title: I18n.t("No result were found."),
      text: I18n.t("Try again with another keyword/filter or:"),
      children: JsxRuntime.jsx(Button.make, {
        label: I18n.t("Clear search query and filters"),
        onPress: () => dispatch({
          TAG: "Reset",
          _0: initialState
        })
      })
    });
  }
  if (pageSubtitle !== undefined) {
    return JsxRuntime.jsx(Scaffolded.make, {
      title: I18n.t("Stock activities"),
      subtitle: pageSubtitle,
      state: state,
      dispatch: dispatch,
      columns: columns,
      filters: filters,
      searchBar: searchBar,
      emptyState: emptyState,
      defaultQueryVariables: defaultQueryVariables
    });
  } else {
    return JsxRuntime.jsx(Placeholder.make, {
      status: "Error"
    });
  }
}

let make = React.memo(CatalogVariantStockActivityPage);

export {
  ParentQuery,
  Query,
  Filters,
  KindFilter,
  Row,
  Scaffolded,
  use$2 as use,
  make,
}
/* query Not a pure module */
